var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _c(
      "div",
      { staticClass: "flex items-center mb-2" },
      [
        _c("Skeleton", {
          staticClass: "mr-2",
          attrs: { width: 31, height: 31, type: "circle" },
        }),
        _c("Skeleton", {
          staticClass: "rounded-full mr-2",
          attrs: { width: 400, height: 24 },
        }),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "px-10 mb-5" },
      [
        _vm._l([1, 2, 3], function (i) {
          return _c(
            "div",
            { key: i, staticClass: "flex items-center py-2" },
            [
              _c("Skeleton", {
                staticClass: "mr-2",
                attrs: { width: 24, height: 24, type: "circle" },
              }),
              _c("Skeleton", { attrs: { width: 250, height: 16 } }),
            ],
            1
          )
        }),
        _c(
          "div",
          { staticClass: "pl-7" },
          [_c("Skeleton", { attrs: { width: 250, height: 48 } })],
          1
        ),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }